<template>
    <div class="area-trends-details">
        <moduleTitle title="地区概况"></moduleTitle>
        <p class="area-trends-details-font">安阳，简称殷、邺，是河南省下辖地级市，位于河南省最北部，地处山
            西、河北、河南三省交汇处，西倚太行山，东连华北平原，北邻邯郸，南接鹤壁、新乡。
            安阳是国家历史文化名城，中国八大古都之一，甲骨文最早发现地，周易的发源地，是早期中国华夏文明的中心之一，先后
            有商朝以及曹魏、后赵、冉魏、前燕、东魏、北齐等七朝在此建都，故安阳素有“七朝古都”之称。 安阳殷墟是
            中国历史上第一个有文献可考、并为考古学和甲骨文所证实的都城遗址。截至2015年安阳拥有两项世界文化遗产，分别是
            殷墟和中国大运河（永济渠）。
        </p>
        <moduleTitle title="地区动态"></moduleTitle>
        <div class="trends-list">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
                <van-cell @click="viewDdetails">
                    <p class="trends-title">
                        我市广大党员干部群众认真学习、热议省委书记王国生在安调研讲话精神
                    </p>
                    <p class="trends-time">2019-12-10 8:45:12</p>
                </van-cell>
                <van-cell @click="viewDdetails">
                    <p class="trends-title">
                        我市广大党员干部群众认真学习、热议省委书记王国生在安调研讲话精神
                    </p>
                    <p class="trends-time">2019-12-10 8:45:12</p>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>
<script>
    import moduleTitle from '../../components/ModuleTitle.vue'
    export default {
        data() {
            return {
                list: [],
                loading: false,
                finished: true,
                show:true
            }
        },
        components: {
            moduleTitle,
        },
        methods:{
            viewDdetails(){
                this.$router.push({path:"/dynamicDetails"})
            },
            onLoad(){

            },
        }
    }
</script>
<style>
    .area-trends-details {
        width: 670px;
        margin: 0 auto;
        padding: 32px 0 40px 0;
    }

    .area-trends-details-font {
        font-size: 30px;
        line-height: 46px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #333333;
        margin: 25px auto;
        text-align: left;
        width: 642px;
    }
    .trends-title{
        font-size:34px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:48px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .trends-time{
        font-size:24px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(166,166,166,1);
        line-height:33px;
        margin-top: 16px;
    }
    .trends-list .van-cell{
        padding-left: 14px;
        padding-right: 14px;
    }
    .van-cell:not(:last-child)::after{
        border-color: #EFEFEF;
    }
</style>